<div id="login-wrapper">
  <div id="login-info">
    <div id="login-header">
      <img id="por-iot-logo" src="../../assets/images/logo.svg" alt="">
    </div>
    <div id="login-text" class="h6">
      Welcome to the IoT platform of Port of Rotterdam.<br>
      Here you can start managing the sensors and you can start your journey here!
    </div>

    <div id="login-button-wrapper">
      <button
        class="btn btn-primary h5"
        id="login-button"
        (click)="onLoginClicked()"
      >Login</button>
    </div>
  </div>
</div>
